module.exports = __webpack_public_path__ + "static/B01-a85b123bcaa1d61ec595c0fabf7a2624.jpg";